import React from 'react';
import { Retry } from '@src/components/common';
import WidgetErrorBoundary from '../../common/FlowErrorBoundary';
import RowData from './RowData';
import type { ColumnWidths } from '../types';

interface ActiveFlowRowProps {
  flowMeta: any;
  query: any;
  columnWidths: ColumnWidths;
}

const ActiveFlowRow: React.FC<ActiveFlowRowProps> = ({ flowMeta, query, columnWidths }) => {
  return (
    <WidgetErrorBoundary fid={flowMeta.id} key={flowMeta.id}>
      <Retry
        progress
        isLoading={query.isFetching}
        showError={query.isError}
        fetchData={query.refetch}
        queued={query.queued}
        horizontal={true}
        compact={true}
      >
        <RowData flowMeta={flowMeta} data={query.data} columnWidths={columnWidths} />
      </Retry>
    </WidgetErrorBoundary>
  );
};

export default ActiveFlowRow;
